import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Nav } from '@alicloud/console-components';
/**
 * @public
 */

var Divider = styled(Nav.Divider)(_templateObject());
export default Divider;